export enum SubscriptionCheckoutQueryString {
  ID = "id",
  STATE = "state",
}
